
import PaginateButton from "../../../../../shared/PaginateButton/PaginateButton";

import { setTrialUserCurrentPage } from "../../../../../store/features/AdminPanel/User/UserSlice";
import { RootStore, useAppDispatch, useAppSelector } from "../../../../../store/store";
import "./index.scss";

const TrialUserFooter = () => {
  const dispatch = useAppDispatch();
  const userState: any = useAppSelector((store: RootStore) => {
    return store.UserSlice;
  });
  const handlePagination = (num: number) => {
    dispatch(setTrialUserCurrentPage(num+1))
  };
  return (
    <div className="mentor__pagination__section">
      <PaginateButton
        paginate={handlePagination}
        totalRows={userState?.trial_user_pagination_data?.total}
      />
    </div>
  );
};

export default TrialUserFooter;
